var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgEyeOff = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye-off",
    clipPath: "url(#clip0_999_1256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M8.24992 3.53337C8.82353 3.39911 9.4108 3.33199 9.99992 3.33337C15.8333 3.33337 19.1666 10 19.1666 10C18.6607 10.9464 18.0575 11.8373 17.3666 12.6584M11.7666 11.7667C11.5377 12.0123 11.2617 12.2093 10.955 12.346C10.6484 12.4826 10.3173 12.5561 9.98166 12.562C9.64598 12.5679 9.31255 12.5062 9.00126 12.3804C8.68997 12.2547 8.40719 12.0676 8.16979 11.8302C7.93239 11.5928 7.74525 11.31 7.61951 10.9987C7.49377 10.6874 7.43202 10.354 7.43795 10.0183C7.44387 9.68262 7.51734 9.35158 7.65398 9.04491C7.79062 8.73825 7.98763 8.46225 8.23325 8.23337M0.833252 0.833374L19.1666 19.1667M14.9499 14.95C13.5254 16.0359 11.7908 16.6374 9.99992 16.6667C4.16658 16.6667 0.833252 10 0.833252 10C1.86983 8.06829 3.30753 6.38055 5.04992 5.05004L14.9499 14.95Z",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_999_1256"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEyeOff, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/eye-off.eeac9fe9.svg";
export { ForwardRef as ReactComponent };